import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=2a113c4a&scoped=true&"
import script from "./Pill.vue?vue&type=script&lang=ts&"
export * from "./Pill.vue?vue&type=script&lang=ts&"
import style0 from "./Pill.vue?vue&type=style&index=0&id=2a113c4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a113c4a",
  null
  
)

export default component.exports